import type { ExplorationVolume, ViewMode } from '../../types/exploration';
import { currentInnerPalette } from './sidebarPalettes';

export interface SidebarStorageMetric {
  title: string;
  size: number;
  count: number;
}

/**
 * The two stat boxes shown for a scope of volumes — shared by the side panel's
 * top card (SidebarStorageCard) and the bubble hover tooltip (groupBreakdownCardHtml)
 * so the two surfaces can't drift apart on which fields they show. Single pass over
 * `scoped` since the tooltip path runs this on every bubble hover.
 */
export function computeSidebarStorageMetrics(
  scoped: ExplorationVolume[],
  view: ViewMode
): SidebarStorageMetric[] {
  const palette = currentInnerPalette(view);
  const signalKey = palette.order[0];
  const isActivationView = view === 'activation';

  let totalSize = 0;
  let signalSize = 0;
  let signalCount = 0;
  let potentialSize = 0;
  let potentialCount = 0;
  for (const v of scoped) {
    const size = v.size || 0;
    totalSize += size;
    if (v[palette.field] === signalKey) {
      signalSize += size;
      signalCount++;
    }
    if (isActivationView && (v.isDatafiable || v.isPotentiallyDatafiable)) {
      potentialSize += size;
      potentialCount++;
    }
  }

  if (isActivationView) {
    return [
      { title: palette.label(signalKey), size: signalSize, count: signalCount },
      { title: 'Potential', size: potentialSize, count: potentialCount },
    ];
  }

  return [
    { title: 'Storage detected', size: totalSize, count: scoped.length },
    { title: palette.label(signalKey), size: signalSize, count: signalCount },
  ];
}
